import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { Box, Button, Grid, IconButton, Modal, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import BitacoraItemMotivo from "@/erp/sale/pages/bitacora/componente/bitacora_item_motivo/BitacoraItemMotivo";
import { useAuthStore } from "@/store/auth";
import { useIsMediaQuery } from "@/shared";
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import BitacoraGroupButton from "../BitacoraGroupButton/BitacoraGroupButton";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { EstadoMotivoEnum } from "@/shared/interfaces";
import { useMemo } from "react";
export default function ComentariosBitacoraDialog() {

  ///* socket

  const dataGetVentaById = useDiccionarioMotivo(s => s.dataGetVentaById)
  const open = useDiccionarioMotivo(s => s.open)
  const setOpenCreaBitacora = useDiccionarioMotivo(s => s.setOpenCreaBitacora)
  const setDetalle = useDiccionarioMotivo(s => s.setDetalle)
  //const setOpen = useDiccionarioMotivo(s => s.setOpen)
  const socket = useDiccionarioMotivo(s => s.socket)
  const setValueTab = useDiccionarioMotivo(s => s.setValueTab)
  const setCloseBitacora = useDiccionarioMotivo(s => s.setCloseBitacora)
  const openRead = useDiccionarioMotivo(s => s.openRead)
  const valueTab = useDiccionarioMotivo(s => s.valueTab)
  const username = useAuthStore(s => s.user)?.username

  const isMobile = useIsMediaQuery("sm");

  const motivos = useMemo(() => {
    return dataGetVentaById?.diccionario_motivo.flatMap(dm =>
      dm.motivos.filter(e => e.estado_motivo ===
        (valueTab == 1
          ? EstadoMotivoEnum.NO_RESUELTO
          : EstadoMotivoEnum.RESUELTO)).map(motivo => ({
            ...motivo,
            descripcion: motivo.descripcion,
            diccionario_motivo_id: dm._id,
            fase_venta: dm.fase_venta,
          }))
    ) || [];

  }, [dataGetVentaById, valueTab]);

  if (!open) return null;

  return (
    <>

      {
        dataGetVentaById && open && (
          <Modal
            onClose={() => {
              setCloseBitacora();
              socket?.emit('leaveRoom', (username))

            }}
            open={open}
          >
            <Box
              sx={{
                overflow: 'auto',
                //height: '600px',
                width: isMobile ? '90%' : '75%',
                maxHeight: isMobile ? '90%' : '600px',
                p: 1,
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                boxShadow: 24,
                borderRadius: 1,
                outline: 'none',
              }}
            >

              <Grid container
                spacing={1}
                alignItems={'center'}
                justifyContent={'space-between'}
              >
                <Grid item xs={12}>
                  <Box sx={{
                    display: "flex", alignItems: "center",
                    padding: 1,
                    bgcolor: "background.paper",
                    background: '#2C4E80'
                  }}>
                    <AutoStoriesIcon fontSize="large" sx={{ color: 'white', marginRight: '10px', height: '100%' }} />

                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="h5" color={'white'}>{'Bitacora'}</Typography>

                      <Typography variant="subtitle2" color={'white'}>
                        {`${dataGetVentaById.identificacion_cliente} / ${dataGetVentaById.nombre_cliente} / MOTIVOS SIN RESOLVER`}
                      </Typography>
                    </Box>
                    <IconButton onClick={() => setCloseBitacora()}>
                      <Close style={{
                        color: 'white'
                      }} />
                    </IconButton>
                  </Box>

                </Grid>

                <Grid item xs={8} sm={8} md={4} xl={4} >
                  <BitacoraGroupButton
                    handleButtonClick={(index) => {
                      setValueTab(index)
                    }}
                    activeButton={valueTab}
                  />
                </Grid>

                {
                  !openRead && (
                    <Grid item
                      xs={4} sm={4} md={3} xl={3}
                      textAlign={'end'}>
                      <Button
                        size="small"
                        startIcon={<AddCircleIcon />}
                        variant="text"
                        onClick={() => {

                          const detail = {
                            numero_referencia_venta: dataGetVentaById.numero_referencia_venta,
                            identificacion_cliente: dataGetVentaById.identificacion_cliente || '',
                            nombre_cliente: dataGetVentaById.nombre_cliente || '',
                            canal_venta: dataGetVentaById.canal_venta || '',
                            vendedor: username,
                          };

                          setOpenCreaBitacora(true)
                          setDetalle(detail)
                        }}
                      >
                        AGREGAR
                      </Button>
                    </Grid>
                  )
                }


                <Grid item xs={12}>

                  {motivos.length === 0 && (
                    <Typography
                      textAlign={'center'}
                      variant="body1"
                    >
                      No hay motivos.
                    </Typography>

                  )}

                  {
                    motivos.map((element) => {
                      return <Grid container>
                        <Grid item xs={12}>
                          <BitacoraItemMotivo
                            esLectura={openRead}
                            motivo_data={element}
                            key={element._id}
                            panelId={element._id}
                            diccionario_motivo_id={element.diccionario_motivo_id}
                            numero_referencia_venta={dataGetVentaById.numero_referencia_venta}
                            fase_venta={element.fase_venta}
                            fecha_creacion_motivo={element.createdAt}
                          />
                        </Grid>
                      </Grid>
                    })
                  }

                </Grid>


              </Grid>
            </Box>

          </Modal>
        )
      }
    </>
  )

}